export default __webpack_public_path__ + "static/media/sm_all.b08ec21d.png";